import { Spinner } from "@heroui/react";

const LoadingScreen = () => (
  <div className="absolute left-0 top-0 z-[9999] w-screen h-screen flex items-center justify-center">
    <Spinner size="lg" />
  </div>
);

export default LoadingScreen;